import { WEB_COMPONENT_GZ_PURCHASE_PAGE } from '../../../../../webcomponents.constants';
import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { GzImageRepoWebComponent } from '../../../../../ui/gzImageRepo';
import { GzTitleWebComponent } from '../../../../../ui/gzTitle';
import { GzTextWebComponent } from '../../../../../ui/gzText';
import { GzLinkWebComponent } from '../../../../../ui/gzLinkComponent';
import { TemplateState } from '../../../../../types/common/types';
import { PlansAndPurchaseTabViewData } from '../types/types';
import { ImageState } from '../../../../../ui/gzImageRepo/types';
import { GzPurchasePageWebComponent } from '../../purchasePage/gzPurchasePage';
import { SwitchValue } from '../../purchasePage/types';

export class PlansAndPurchaseTabView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $gzPurchasePage: GzPurchasePageWebComponent;
    $errorContainer: {
      $image: GzImageRepoWebComponent;
      $title: GzTitleWebComponent;
      $text: GzTextWebComponent;
      $link: GzLinkWebComponent;
    };
  };

  private isLoading: boolean;

  public hasErrorState = false;

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $gzPurchasePage: this.shadow.querySelector(WEB_COMPONENT_GZ_PURCHASE_PAGE),
      $errorContainer: {
        $image: this.shadow.querySelector('#in-product-buy-error-image'),
        $title: this.shadow.querySelector('#in-product-buy-error-title'),
        $text: this.shadow.querySelector('#in-product-buy-error-text'),
        $link: this.shadow.querySelector('#in-product-buy-error-link'),
      },
    };
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
    this.isLoading = true;
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.isLoading = false;
  }

  buildSuccessView(data: PlansAndPurchaseTabViewData) {
    const extendableProducts = data.getPlansAndPurchaseDataResponse.extendableProducts;
    const purchasableProducts = data.getPlansAndPurchaseDataResponse.purchasableProducts;

    this.dom.$gzPurchasePage.purchasePageDataProvider = data.purchasePageDataProvider;
    if (data.getPlansAndPurchaseDataResponse.noExtendableProductsReason) {
      this.dom.$gzPurchasePage.setNoExtendableProductsReason(data.getPlansAndPurchaseDataResponse.noExtendableProductsReason);
    }
    this.dom.$gzPurchasePage.setProducts(extendableProducts).catch(err => console.error(err));
    this.dom.$gzPurchasePage.setProductsToBuy(purchasableProducts);

    this.removeLoadingState();

    this.hasErrorState = false;
  }

  public buildErrorView(error: Error) {
    console.error(error);

    this.hasErrorState = true;

    // error state
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);

    // set message and image state
    this.dom.$errorContainer.$text.innerText = this.dependencies.translateFn(
      'Data loading has failed. Please try to refresh the page and if the issue persists contact Bitdefender Enterprise Support for more information.'
    );
    this.dom.$errorContainer.$image.state = ImageState.ERROR;
  }

  setSelectedProduct(productId: number, switchValue = SwitchValue.ExtendSeats) {
    if (this.isLoading) {
      this.dom.$gzPurchasePage.setProductToBeSelectedAfterLoad(productId, switchValue);
    } else {
      this.dom.$gzPurchasePage.setSelectedProduct(productId, switchValue);
    }
  }
}
